//React
import React from "react";
import {
  Link
} from "react-router-dom";

import axios from 'axios';
import config from '../config';

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as uiAction from '../action/uiAction';
import * as mailTalkAction from '../action/mailTalkAction';
import * as mailGroupAction from '../action/mailGroupAction';
import * as mailDraftAction from '../action/mailDraftAction';
import * as partnerOperationAction from '../action/partnerOperationAction';
import * as lightboxAction from '../action/lightboxAction';
import * as helpAction from '../action/helpAction';
import * as guideAction from '../action/guideAction';
//Material-ui
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';

import LinearProgress from '@material-ui/core/LinearProgress';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Fab from '@material-ui/core/Fab';
//Socket
import io from 'socket.io-client';
//func
import atom2datetime from '../func/atom2datetime';
//Add
import Cookies from 'js-cookie';
import TextareaAutosize from 'react-textarea-autosize';
import ReactPaginate from 'react-paginate';
import { LazyLoadImage } from 'react-lazy-load-image-component';
//Dialog
import DialogConfirm from './DialogConfirm';
import DialogPhotoMailSelect from './DialogPhotoMailSelect';
import DialogVoiceMailRecord from './DialogVoiceMailRecord';
import DialogTextMailSend from './DialogTextMailSend';
import DialogVideoMailPlay from './DialogVideoMailPlay';


//Part
import PartUserMainImg from './PartUserMainImg';
import PartUserName from './PartUserName';
import PartBreachCardIcon from './PartBreachCardIcon';
//Icon
import MailIcon from '@material-ui/icons/Mail';
import RefreshIcon from '@material-ui/icons/Refresh';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import StopIcon from '@material-ui/icons/Stop';
import CameraAltIcon from '@material-ui/icons/CameraAlt';
import MicIcon from '@material-ui/icons/Mic';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import MoreVertSharpIcon from '@material-ui/icons/MoreVertSharp';
import HelpIcon from '@material-ui/icons/Help';
//Img
import Blank from '../img/blank/blank-1x1.gif';

class Comp extends React.Component {
  constructor(props) {
    super(props);
    this.mailListRef = React.createRef();
    this.textareaRef = React.createRef();

  	this.state = {
      pic: this.props.match.params.pic,
      partnerName: null,
      partnerImg: null,
      partnerSex: null,
      partnerBreachCard: null,
      partnerStop: null,
      partnerAttestation: null,

      mailSendCheckBool: false,
      mailSendCheckType: null,
      mailSendCheckComment: null,
      mailSendCheckLeft:　0,
      mailSendCheckNomatch: {
        important: [],
        age: null,
      },

      mailListInit: true,
      mailListPage: 1,
      mailList: [],
      mailDatetime: null,
      mailListTotalCount: 0,
      mailListOutputCount: 1,
      mailListBlockHeight: 600,
      mailListInnerBlockHeight: 'auto',

      mailDelId: null,
      mailDelAnchor: null,

      voicePlayingIndex: null,
      voicePlayingDuration: null,
      voicePlayingTime: 0,
      loading: false,
      videoPlayUri: null,

      textareaText: '',
      textareaTextLimit: 0,
      textareaTextInit: '',
      textareaFocus: false,
      textareaMinRows: 2,
      textareaMaxRows: 2,
      textMailDialogVisible: false,

      photoMailImageBase64: null,

      voiceMailAudioWav: null,

      imgMaxSize: 300,

      dialogTextMailSendVisible: false,
      dialogTextMailApproachSendVisible: false,
      dialogPhotoMailVisible: false,
      dialogVoiceMailVisible: false,
  	}
    window.addEventListener('resize', this._adjustBlockHeight);
  }

  componentDidMount() {
    let uidArr = [this.state.pic, this.props.auth.uic];
    uidArr.sort();
    this.socket = io(this.props.config.socketEndpint, {
      query: 'room=' + uidArr.join('-') + '&uid=' + this.props.auth.uic
    });
    console.log(this.socket);

    this._ready(this.state.pic, this.state.mailListPage, true);

    document.body.classList.add('hidden');
    this.socket.on('reload', () => {
      this._mailTalkListGet(1, false);
    });
  }

  async _ready(pic, page, scrollBottom) {
    await this._mailSendCheck(pic);
    await this._mailTalkListGet(page, scrollBottom);
    this.props.mailDraftItemGet(pic, (data) => {
      if (data.draft) {
        this.setState({textareaText: data.draft, textareaTextInit:data.draft});
      }
    })
  }


  componentDidUpdate(prevProps, prevState) {
    if (this.state.textareaMaxHeight !== prevState.textareaMaxHeight) {
      this._adjustBlockHeight();
    }
    if (this.state.mailListBlockHeight !== prevState.mailListBlockHeight) {
      let diff = prevState.mailListBlockHeight - this.state.mailListBlockHeight;
      if (diff > 0) {
        let scroll = this.mailListRef.current.scrollTop + diff;
        document.getElementById('mail_list_block').scrollTo(0, scroll);
      }
    }

  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._adjustBlockHeight);
    this.socket.disconnect();
    if ((this.state.textareaTextInit !== this.state.textareaText) && (this.state.partnerAttestation === 1) && (this.state.textareaText.length < 1500)) {
      this._mailDraftSave();
    }
    document.body.classList.remove('hidden');
    console.log('clearUnmount');
  }

  _mailSendCheck(pic) {
    this.props.mailSendCheck(pic, (data) => {
      this.setState({
        mailSendCheckType: data.type,
        mailSendCheckBool: data.check,
        mailSendCheckComment: data.comment,
        mailSendCheckLeft: data.left,
        mailSendCheckNomatch: data.nomatch,
      });
      if (data.type === 'free') {
        this.setState({textareaTextLimit: 1000});
      }
      else {
        this.setState({textareaTextLimit: 100});
      }
    });
  }

  _mailTalkListGet(page, scrollBottom) {
    this.props.mailTalkListGet(this.state.pic, page, (data) => {
      this.setState({
        partnerName: data.profile.userdata_name,
        partnerMainImg: data.profile.userdata_mainImg,
        partnerSex: data.profile.userdata_sex,
        partnerBreachCard: data.profile.breachCard,
        partnerStop: data.profile.userdata_service_stop,
        partnerAttestation: data.profile.userdata_attestation,
        mailListInit: false,
        mailListPage: page,
        mailList: data.list,
        mailListDatetime: (new Date()),
        mailListTotalCount: data.totalCount,
        mailListOutputCount: data.outputCount,
      });
      if (!data.profile.userdata_id_code) {
        this.props.history.push('/mailbox/');
      }
      else {
        document.title = data.profile.userdata_name + 'さんとのトーク - パートナーズ';
        this._adjustBlockHeight();
        if (scrollBottom) {
          this._scrollBottom();
        }
        this.props.mailGroupItemConfirmed(this.state.pic);
      }
    });
  }

  _adjustBlockHeight = () => {
    console.log('adjust');
    //画像のサイズ
    let imgMaxSize;
    if ((window.innerWidth * 0.7) > 300) {
      imgMaxSize = 300;
    }
    else {
      imgMaxSize = (window.innerWidth * 0.7);
    }
    this.setState({imgMaxSize: imgMaxSize});
    //メールブロック
    let height = document.documentElement.clientHeight - (document.getElementById('mail_menu_block').clientHeight + document.getElementById('mail_form_block').clientHeight);
    this.setState({ mailListBlockHeight: (height + 2)});
  }



  _renderMailTalk() {
    let list;
    if (this.state.mailListDatetime) {
      if (this.state.mailList.length > 0) {
        list = (
          <div>
            {
              this.state.mailList.map(
                (item, index, arr) => this._renderMailTalkList(item, index, arr)
              )
            }
            {
              this._renderTemplate()
            }
          </div>
        )
      }
      else {
        list = (
          <div style={{position: 'absolute',width: '100%', top:'50%', transform: 'translateY(-50%)'}}>
            <div style={{color:'#FFF',fontSize:'1.1em',fontWeight:'bold'}} align='center'>
              <span className='i-b'>{this.state.partnerName} さんとの</span>
              <span className='i-b'>メールはありません</span>
            </div>

            {
              (this.state.mailSendCheckType === 'noProof') ? (
                (this.props.my.profile.userdata_sex === 'men') ? (
                  <div>
                    <div align='center' style={{margin:'10px'}}>
                      <Link to="/my/proof/person">
                        <Button
                          variant="contained"
                          color='secondary'
                          style={{minWidth:'200px'}}
                        >
                          <div>
                            <div style={{fontSize:'1.2em'}}>本人証明を申請すると<br />無料メールが送信できます</div>
                          </div>
                        </Button>
                      </Link>
                    </div>
                    <div align='center' style={{margin:'10px'}}>
                      <Button
                        color='secondary'
                        variant="outlined"
                        onClick={ () => this.props.guideApproachMailSet(true) }
                      >
                        無料メールとは？
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div align='center' style={{margin:'10px'}}>
                    <Link to="/my/proof/person">
                      <Button
                        variant="contained"
                        color='secondary'
                        style={{minWidth:'200px'}}
                      >
                        <div>
                          <div style={{fontSize:'1.2em'}}>本人証明を申請すると<br />すべて無料でご利用いただけます</div>
                        </div>
                      </Button>
                    </Link>
                  </div>
                )
              ) : (
                <div align='center'>
                  {
                    (this.state.mailSendCheckNomatch.age) && (
                      <div align='center' style={{color:'red'}}>お相手の希望年齢と一致していません</div>
                    )
                  }
                  {
                    (this.state.mailSendCheckNomatch.important.length > 0) && (
                      <div align='center' style={{color:'red'}}>
                        <span className='i-b'>お相手の希望条件(重要)と</span>
                        <span className='i-b'>一致しない項目があります</span>
                      </div>
                    )
                  }
                  {
                    (!this.state.mailSendCheckNomatch.age && this.state.mailSendCheckNomatch.important.length === 0) && (
                      <h3 align='center' style={{margin:'10px 0px'}}>
                        <span className='i-b'>{this.state.partnerName} さんは</span>
                        <span className='i-b'>あなたからのメールを</span>
                        <span className='i-b'>待っているかもしれません</span><br />
                        <span className='i-b'>積極的にアプローチしてみましょう！</span>
                      </h3>
                    )
                  }
                  <div align='center' style={{margin:'10px'}}>
                    <Fab
                      variant="extended"
                      color="primary"
                      onClick={ () => this.textareaRef.current.focus() }
                    >
                      <MailIcon />
                      メールを作成する
                    </Fab>
                  </div>
                  <div align='center' style={{margin:'10px'}}>
                    <Button
                      variant="outlined"
                      onClick={ () => this.props.helpOpen('id',451) }
                    >
                      アプローチメールのアドバイス
                    </Button>
                  </div>
                </div>
              )
            }

          </div>
        )
      }
    }
    else {
      list = null;
    }

    return list;
  }

  _lightboxOpen(selectUri) {
    let photoList = [];

    let mailFilter = this.state.mailList.filter(item => (item.mail_category === 'photo' || item.mail_category === 'photo-send'));
    photoList = mailFilter.map(function(value, index) {
      return {src:mailFilter[index].mail_text};
    });
    photoList = photoList.reverse();
    let selectIndex = photoList.findIndex((v) => v.src === selectUri);
    this.props.lightboxOpen(photoList, selectIndex);
  }

  _renderTemplate() {
    let trans = this.state.mailList.filter((value) => (value.mail_trans_recept === 'trans'));
    if (this.state.mailSendCheckBool === true && trans.length === 0 && this.state.mailListPage === 1) {
      return (
        <div align='center' style={{margin:'15px'}}>
          定型文で返信する
          <div>
            <Button
              variant="outlined"
              onClick={ () => this._template2textarea('定型文で失礼します。\r\n'+this.state.partnerName+'さんメールありがとう御座います。 \r\nお誘いいただいたのにごめんなさい。\r\n良い出会いがあるよう応援しています。') }
            >
              ごめんなさい
            </Button>
          </div>
        </div>
      )
    }
    else {
      return null;
    }
  }

  _template2textarea(value) {
    if (this.state.textareaText) {
      if (window.confirm('既に入力されている本文を書き換えてもいいですか？')) {
        this.setState({
          textareaText: value,
        })
        this._textareaFocus();
      }
    }
    else {
      this.setState({
        textareaText: value,
      })
      this._textareaFocus();
    }

  }

  _renderMailTalkList(item, index, arr) {
    let contents;

    if (item.mail_category === 'photo' || item.mail_category === 'photo-send') {
      contents = (
        <div
          style={{
            position:'relative',
            cursor:'pointer',
          }}
          onClick={ () => this._lightboxOpen(item.mail_text) }
        >
          <LazyLoadImage
            src={ item.mail_text }
            style={{
              width: this.state.imgMaxSize,
              height: this.state.imgMaxSize,
              objectFit:'contain',
            }}
            alt=''
          />

          <img
            src={Blank}
            style={{
              position:'absolute',
              left:0,
              top:0,
              width:'100%',
              height:'100%',
            }}
            alt=''
          />
        </div>
      )
    }
    else if (item.mail_category === 'photo-pending') {
      contents = (
        <div
          style={{
            position:'relative',
          }}
        >
          <img
            src={ item.mail_text }
            style={{
              width: this.state.imgMaxSize,
              height: this.state.imgMaxSize,
              objectFit:'contain',
            }}
            alt=''
          />
          <img
            src={Blank}
            style={{
              position:'absolute',
              left:0,
              top:0,
              width:'100%',
              height:'100%',
            }}
            alt=''
          />
        </div>
      )
    }
    else if (item.mail_category === 'photo_delete') {
      contents = (
        <div
          style={{
            width: this.state.imgMaxSize,
            height: this.state.imgMaxSize,
            background: '#333',
            position:'relative',
          }}
        >
          <div style={{
            position: 'absolute',
            left:0,
            top:0,
            width:'100%',
            height:'100%',
            display:'flex',
            flexDirection:'row',
            justifyContent:'center',
            alignItems:'center',
            color:'#FFF',
          }}>
            <div>
              <span className='i-b'>写真は送信側で</span>
              <span className='i-b'>削除されました</span>
            </div>
          </div>

        </div>
      );
    }
    else if (item.mail_category === 'voice') {
      contents = (
        <div style={{position:'relative'}}>
    			<div>
            <div align='center'>
    				  ボイスメール
            </div>
    				<div align='center'>
    					<span
                className='voiceMailBlock'
                style={{cursor:'pointer'}}
              >
                {
                  (index === this.state.voicePlayingIndex) ? (
                    <div>
                      <IconButton
                        style={{color:'#FFBC57'}}
                        onClick={ () => this._voiceStop() }
                        size='small'
                      >
                        <StopIcon style={{fontSize:'2em'}}/>

                      </IconButton>
                      {
                        (this.state.voicePlayingDuration) && (
                          <div>
                            <div>
                              <LinearProgress variant="determinate" value={ (Math.round(this.state.voicePlayingTime / this.state.voicePlayingDuration * 100)) } />
                            </div>
                            <div>{ this.state.voicePlayingDuration } 秒</div>
                          </div>
                        )
                      }
                    </div>
                  ) : (
                    <div>
                      <IconButton
                        style={{color:'#FFBC57'}}
                        onClick={ () => this._voicePlay(index) }
                        size='small'
                      >
                        <PlayArrowIcon style={{fontSize:'2em'}}/>
                      </IconButton>
                    </div>
                  )
                }

    					</span>
    				</div>
    			</div>
    		</div>
      );
    }
    else if (item.mail_category === 'voice_delete') {
      contents = (
        <div style={{color:'#999'}}>
          <div>ボイスメールは送信側で</div>
          <div>削除されました</div>
        </div>
      )
    }
    else if (item.mail_category === 'video') {
      let uri = item.mail_text.split(',');
      contents = (
        <div style={{position:'relative',backgroundColor:'#000000'}}>
            <img
              src={ uri[1] }
              style={{
                width: this.state.imgMaxSize,
                height: this.state.imgMaxSize,
                objectFit:'contain',
              }}
              alt=''
            />

            <div
              style={{
                position:'absolute',
                top:0,
                left:0,
                height:"100%",
                width: "100%",
                display: 'flex',
                justifyContent:'center',
                alignItems:'center',
                backgroundColor:'rgba(0, 0, 0, 0.5)',
              }}
            >
              <IconButton
                style={{color:'#FFFFFF'}}
                onClick={ () => this._videoPlay(uri[0]) }
                size='small'
              >
                <PlayArrowIcon style={{fontSize:'2em'}}/>
              </IconButton>
  					</div>


        </div>
      )
    }
    else {
      contents = (
        <div style={{whiteSpace: 'pre-line'}}>
          {item.mail_text}
        </div>
      );
    }

    if (item.mail_trans_recept === 'trans') {
      let info_datetime = null;

      if (item.mail_category === 'approach-pending' || item.mail_category === 'photo-pending') {
        info_datetime = (
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'top',
              justifyContent:'space-between',
            }}
          >
            <div style={{color:'#999',fontSize:'0.9em'}}>
              <div>無料メールは審査待ちです<br/>12時間以内に送信されます</div>
            </div>
            <div>
              <IconButton
                size='small'
                onClick={ (event) => this.setState({mailEditId:item.mail_id, mailEditAnchor:event.currentTarget}) }
              >
                <MoreVertSharpIcon
                  style={{fontSize:'1.2em',color:'#999'}}
                />
              </IconButton>
            </div>
          </div>
        )
      }
      else {
        info_datetime = (
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              justifyContent:'space-between',
            }}
          >

            <div style={{fontSize:'0.9em'}}>
              <div style={{color:'#666'}}>
                {atom2datetime(item.mail_transmission_atom, 'DT')}
              </div>
              {
                (item.mail_category === 'approach-send' || item.mail_category === 'photo-send') && (
                  <div style={{color:'#666'}}>無料メールをお相手に送信しました</div>
                )
              }
            </div>
            <div>
              <IconButton
                size='small'
                onClick={ (event) => this.setState({mailEditId:item.mail_id, mailEditAnchor:event.currentTarget}) }
              >
                <MoreVertSharpIcon
                  style={{fontSize:'1.2em',color:'#999'}}
                />
              </IconButton>
            </div>
          </div>
        )
      }

  		return (
        <div key={index} align='right' style={{margin:'10px'}}>

          <div className='talk_balloon_right round12' style={{marginRight:'10px'}}>
            { info_datetime }

            {contents}
          </div>
        </div>
      );
    }
    else if (item.mail_trans_recept === 'recept') {
  		return (
        <div key={index} align='left' style={{margin:'10px'}}>
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'top',
              justifyContent:'start',
            }}
          >
            <span
              style={{cursor:'pointer'}}
              onClick={ () => this.props.history.push('/partner/' + this.state.pic) }
            >
              <PartUserMainImg
                mainImg={this.state.partnerMainImg}
                width={'30px'}
                height={'30px'}
                radius={'50%'}
                background={'#FFF'}
                fontSize={'0.6em'}
              />
            </span>
              {
                (item.mail_category === 'no-proof') ? (
                  <div className='talk_balloon_left round12' style={{marginLeft:'10px'}}>
                    <div
                      style={{
                        display:'flex',
                        flexDirection:'row',
                        alignItems:'top',
                        justifyContent:'space-between',
                      }}
                    >
                      <div style={{fontSize:'0.9em',color:'#666'}}>
                        {atom2datetime(item.mail_transmission_atom, 'DT')}
                      </div>
                    </div>
                    <div style={{whiteSpace:'pre-line',color:'transparent',textShadow:'0px 0px 8px rgba(0, 0, 0, 1)'}}>
                      {contents}
                    </div>
                    <div style={{marginTop:'10px'}}>
                      <div style={{fontSize:'0.9em',color:'#666'}}>
                        {
                          (this.props.my.profile.userdata_sex === 'men') ? (
                            <span>
                              本人証明を申請すると受信メールが表示され、
                              <span className='link' onClick={ () => this.props.guideApproachMailSet(true) }><u>無料メール</u></span>
                              でお返事も送信できます。
                            </span>
                          ) : (
                            <span>
                              本人証明を申請すると受信メールが表示され、
                              <span className='link' onClick={ () => this.props.guidePaymentSet(true, 'women') }><u>すべて無料</u></span>
                              でご利用いただけます。
                            </span>
                          )
                        }
                      </div>

                    </div>
                    <div style={{marginTop:'10px'}}>
                      <Button
                        variant="contained"
                        color='secondary'
                        onClick={ () => this.props.history.push('/my/proof/person') }
                      >
                        本人証明を申請する
                      </Button>
                    </div>
                  </div>
                ): (
                  <div className='talk_balloon_left round12' style={{marginLeft:'10px'}}>
                    <div
                      style={{
                        display:'flex',
                        flexDirection:'row',
                        alignItems:'top',
                        justifyContent:'space-between',
                      }}
                    >
                      <div style={{fontSize:'0.9em',color:'#666'}}>
                        {atom2datetime(item.mail_transmission_atom, 'DT')}
                      </div>
                      &nbsp;
                      <IconButton
                        size='small'
                        onClick={ (event) => this.setState({mailEditId:item.mail_id, mailEditAnchor:event.currentTarget}) }
                      >
                        <MoreVertSharpIcon
                          style={{fontSize:'1.2em',color:'#999'}}
                        />
                      </IconButton>
                    </div>
                    <div style={{whiteSpace: 'pre-line'}}>
                      {contents}
                      {
                        (item.mail_contactinfo_remove === 1) && (
                          <div>
                            <div style={{marginTop:'10px',color:'red'}}>無料サービスの為、連絡先は非表示になっています</div>
                            <div align='right'>
                              <Button
                                variant="outlined"
                                color='primary'
                                onClick={ () => this.props.history.push('/setting/charge/') }
                              >
                                有料サービスのお申し込み
                              </Button>
                            </div>
                          </div>
                        )
                      }
                    </div>
                  </div>
                )
              }
          </div>
        </div>
      );
    }
  };



  _textareaFocus() {

    let maxHeight;

    maxHeight = window.innerHeight * 0.5;

    console.log(Math.floor(maxHeight / 30));
    this.setState({textareaFocus: true, textareaMinRows:4, textareaMaxRows: Math.floor(maxHeight / 30) });
  }

  _textareaBlur() {
    if (this.state.textareaFocus) {
      document.getElementById('textarea').blur();
      this.setState({textareaFocus: false, textareaMinRows:2, textareaMaxRows: 2 });
    }
  }


  _scrollBottom = () => {
    //var element = document.getElementById('mail_list_block');
    //element.scrollIntoView(false);
  	document.getElementById('mail_list_block').scrollTo(0, (this.mailListRef.current.scrollHeight -1));
    console.log(this.mailListRef.current.scrollHeight);
  }


  _voicePlay = (index) => {
    if (this.audio) {
      this._onVoiceStop();
    }

    const src = this.state.mailList[index].mail_text;
    this.setState({voicePlayingIndex: index});
    try {
      this.audio = new Audio(src);
      this.audio.play();

      let duration;
      let time;
      this.audio.addEventListener('timeupdate', function(e) {
        duration = Math.round(e.target.duration * 10) / 10;
        this.setState({voicePlayingDuration: duration});
        time = Math.round(e.target.currentTime * 10) / 10;
        this.setState({voicePlayingTime: time});
      }.bind(this));

      this.audio.addEventListener('ended', function(e) {
				this._voiceStop();
			}.bind(this));
      this.audio.addEventListener('error', function(e) {
				alert('ボイスメールが取得できませんでした。送信直後は音声データ作成中の為、再生できません');
			});
    } catch (e) {
      alert('ブラウザが未対応の為、再生できませんでした');
    }
  }

  _voiceStop = () => {
    this.setState({voicePlayingIndex: null, voicePlayingDuration: null});

    this.audio.pause();
    this.audio.currentTime = 0;
    this.audio = null;
  }

  _videoPlay = async (src) => {
    await this.setState({videoPlayUri: src});
  }

  _mailDraftSave() {
    const text = this.state.textareaText;
    if (text) {
      this.props.mailDraftSave(this.state.pic, text);
    }
    else {
      this.props.mailDraftDel(this.state.pic);
    }
    this.setState({textareaTextInit: text});
  }

  _mailSubmit(category) {
    if (category === 'free' || category === 'approach-pending') {
      const text = this.state.textareaText;
      this.props.mailSendText(this.state.pic, category, text, (data) => {
        this._ready(this.state.pic, 1, true);
        this.setState({
          dialogTextMailSendVisible: false,
          dialogTextMailApproachSendVisible: false,
          textareaText: '',
        });
        this._textareaBlur();
        this.socket.emit('mail_send');
      });
    }
    else if (category === 'photo' || category === 'photo-pending') {
      const photoBase64 = this.state.photoMailImageBase64;
      this.props.mailSendPhoto(this.state.pic, category, photoBase64, (data) => {
        this._ready(this.state.pic, 1, true);
        this.setState({ dialogPhotoMailVisible:false, photoMailImageBase64:null});
        this._textareaBlur();
        this.socket.emit('mail_send');
      });
    }
    else if (category === 'voice') {
      const wav = this.state.voiceMailAudioWav;
      this.props.mailSendVoice(this.state.pic, category, wav, (data) => {
        this._ready(this.state.pic, 1, true);
        this.setState({ dialogVoiceMailVisible:false, voiceMailAudioWav:null});
        this._textareaBlur();
        this.socket.emit('mail_send');
      });
    }
  }

  _historyBack() {
		if (this.props.location.referrer) {
      this.props.history.goBack();
	  }
		else{
	    this.props.history.push('/mailbox/');
	  }
  }

  _renderMailDelMenu(mailEditId) {
    let comp;
    let index = this.state.mailList.findIndex((item) => item.mail_id === mailEditId);

		if (index >= 0) {
      if (this.state.mailList[index].mail_trans_recept === 'trans') {
        if (this.state.mailList[index].mail_category === 'photo') {
          comp = (<div>※削除すると画像データは<br/>お相手のメールボックスからも<br/>削除されます</div>);
        }
        else if (this.state.mailList[index].mail_category === 'photo-send') {
          comp = (<div>※削除すると画像データは<br/>お相手のメールボックスからも<br/>削除されます</div>);
        }
        else if (this.state.mailList[index].mail_category === 'voice') {
          comp = (<div>※削除するとボイスデータは<br/>お相手のメールボックスからも<br/>削除されます</div>);
        }
        else if (this.state.mailList[index].mail_category === 'approach-pending') {
          comp = (<div>※無料メールは削除すると<br/>再度送信できます</div>);
        }
        else if (this.state.mailList[index].mail_category === 'photo-pending') {
          comp = (<div>※無料メールは削除すると<br/>再度送信できます</div>);
        }
        else {
          comp = (<div>※削除してもお相手の<br/>メールボックスからは<br/>削除されません</div>);
        }
      }
      else {
        comp = null;
      }
		}
    else {
      comp = null
    }

    return comp;
  }

  _mailDelSubmit(mailId) {
    let params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('mailId', mailId);
    axios.post(config.apiUri + "member/mailTalkEditApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      if (res.data.bool) {
        let list = this.state.mailList;
        let index = list.findIndex((v) => v.mail_id === mailId);
        if (index >= 0) {
    		  list.splice( index, 1 );
        }
        this.setState({mailList: list});
        this._mailSendCheck(this.state.pic);
      }
    })
    .catch((err) => {
      this.props.snackOpen('error', 'インターネットに接続できませんでした', 5000);
    })
  }


  render() {



    let textareaTextValid = false;
    let textareaTextValidComment = null;

    if (this.state.textareaTextLimit >= this.state.textareaText.length) {
      textareaTextValidComment = (<span>{this.state.textareaText.length}/{this.state.textareaTextLimit}文字</span>);
      if (this.state.textareaText.length > 0) {
        textareaTextValid = true;
      }
    }
    else {
      textareaTextValidComment = (
        <span style={{
          position:'relative',
          display:'inline-block',
          margin:'2px',
          padding:'3px 6px',
          background:'red',
          textAlign:'left',
          zIndex:'10',
          color:'#FFF',
          borderRadius:'12px',
          fontSize:'1em',
        }}>
          <div style={{
            position: 'absolute',
            content: ' ',
            top: '-8px',
            right: '10px',
            marginLeft: '5px',
            borderStyle: 'solid',
            borderWidth: '0px 5px 10px 5px',
            borderColor: 'transparent transparent red transparent',
          }} />
          {((this.state.textareaTextLimit - this.state.textareaText.length) * -1)}文字オーバー
        </span>
      );
      textareaTextValid = false;
    }

    return (
      <Box id='mail_block' style={{maxWidth:'600px', margin:'auto', overflow:'hidden'}} className='box_inner' boxShadow={2}>
        <div style={{width:'100%', display:'flex', flexDirection:'column'}} border='0'>
            <div
              id ='mail_menu_block'
              style={{
                display:'flex',
                flexDirection:'row',
                alignItems:'center',
                justifyContent:'space-between',
                background:'#F5F5F5',
                position:'relative',
              }}
              className='shadow'
            >
              <div style={{width:'auto',whiteSpace:'nowrap', overflow:'hidden',textOverflow:'ellipsis',}}>
                <div style={{display:'flex',flexDirection:'row',justifyContent:'first', alignItems:'center'}}>
                  <IconButton onClick={ () => this._historyBack() }>
                    <ArrowBackIosIcon />
                  </IconButton>
                  {
                    (this.state.partnerMainImg) && (
                      <span
                        style={{cursor:'pointer'}}
                        onClick={ () => this.props.history.push('/partner/' + this.state.pic) }
                      >
                        <PartUserMainImg
                          mainImg={this.state.partnerMainImg}
                          width={'35px'}
                          height={'35px'}
                          radius={'50%'}
                          background={'#FFF'}
                        />
                      </span>
                    )
                  }
                  &nbsp;
                  <span
                    style={{cursor:'pointer'}}
                    onClick={ () => this.props.history.push('/partner/' + this.state.pic) }
                  >
                    <PartUserName
                      data={{
                        name: this.state.partnerName,
                        sex: this.state.partnerSex,
                        size: '1.2em',
                      }}
                    />


                  </span>


                </div>

              </div>

              <div style={{whiteSpace:'nowrap'}}>
                <IconButton
                  onClick={ () => this.props.partnerOperationOpen(this.state.pic, ['linkProfile', 'memo', 'breach', 'refusal']) }
                >
                  <MoreVertSharpIcon />
                </IconButton>
                <IconButton
                  onClick={ () => this.props.helpOpen('category','mail') }
                >
                  <HelpIcon/>
                </IconButton>

                <IconButton
                  onClick={ () => this._mailTalkListGet(1, true) }
                >
                  <RefreshIcon/>
                </IconButton>

              </div>

            </div>

            <div style={{background:'#bdcee0', position:'relative'}}>
              <div
                id='mail_list_block'
                style={{
                  overflowY:'scroll',
                  WebkitOverflowScrolling: 'touch',
                  width: '100%',
                  height: this.state.mailListBlockHeight+'px',
                  verticalAlign: 'bottom',

                }}
                ref={this.mailListRef}
              >
                <div
                  style={{
                    minHeight:'100%',
                    paddingTop:'10px',
                    display:'flex',
                    flexDirection:'column',
                  }}
                >
                  {
                    (Math.ceil(this.state.mailListTotalCount / this.state.mailListOutputCount) > 1) && (
                      <div style={{textAlign:'center',margin:'10px'}}>
                        <ReactPaginate
                          breakLabel="…"
                          previousLabel="<"
                          nextLabel=">"
                          onPageChange={ (event) => this._mailTalkListGet((event.selected + 1), true) }
                          pageRangeDisplayed={3}
                          marginPagesDisplayed={1}
                          pageCount={ Math.ceil(this.state.mailListTotalCount / this.state.mailListOutputCount) }
                          renderOnZeroPageCount={null}
                          containerClassName={'pagingBlock'}
                          pageLinkClassName={'item'}
                          previousLinkClassName={'item'}
                          nextLinkClassName={'item'}
                          activeLinkClassName={'select'}
                          disabledClassName={'itemDisabled'}
                        />
                      </div>
                    )
                  }
                  <div style={{marginTop:'auto'}}>
                  {
                    this._renderMailTalk()
                  }
                  {
                    (this.state.partnerBreachCard) && (
                      <div align='center' style={{margin:'10px'}}>
                        <PartBreachCardIcon breach={this.state.partnerBreachCard} />
                      </div>
                    )
                  }
                  {
                    (this.state.partnerStop) ? (
                      <div align='center' style={{margin:'10px'}}>
                        {
                          (this.state.partnerAttestation === 1) ? (
                            <>
                              <h3>{this.state.partnerName}さんはサービス停止中の為  </h3>
                              <h3>メールは送信できません </h3>
                              <Button
                                variant="outlined"
                                color="primary"
                                onClick={ () => this.props.helpOpen('id','410') }
                                style={{margin:'5px'}}
                              >
                                停止とはどのような状態？
                              </Button>
                            </>
                          ): (
                            <>
                              <h3>{this.state.partnerName}さんは退会された為</h3>
                              <h3>メールは送信できません</h3>
                              <Button
                                variant="outlined"
                                color="primary"
                                onClick={ () => this.props.helpOpen('id','411') }
                                style={{margin:'5px'}}
                              >
                                退会とはどのような状態？
                              </Button>
                            </>
                          )
                        }

                      </div>
                    ): (
                      null
                    )
                  }

                  </div>


                  <Menu
                    anchorEl={this.state.mailEditAnchor}
                    keepMounted
                    open={(this.state.mailEditId)? true: false}
                    onClick={ () => this.setState({mailEditId: null}) }
                  >
                    <MenuItem
                      onClick={ () => {
                        this._mailDelSubmit(this.state.mailEditId);
                        this.setState({mailEditId: null});
                      }}
                    >
                      <div>

                          メールを削除する
                          <div style={{fontSize:'0.9em',color:'#666',maxWidth:'240px'}}>
                          {
                            this._renderMailDelMenu(this.state.mailEditId)
                          }
                          </div>
                      </div>

                    </MenuItem>
                  </Menu>

                  <DialogConfirm
                    open={ (this.state.mailDelId) ? true : false }
                    title={'メールの削除'}
                    content={'メールを1件削除してもいいですか？'}
                    apply={ () => {
                        this._mailDelSubmit(this.state.mailDelId);
                        this.setState({mailDelId: null});
                      }
                    }
                    close={ () => this.setState({mailDelId: null}) }
                  />

                  <DialogConfirm
                    open={ (this.state.mailApproachDelId) ? true : false }
                    title={'無料メールの削除'}
                    content={(
                    <div>
                      <div>申請中の無料メールを1件削除してもいいですか？</div>
                      <div>※削除後に再度送信いただけます</div>
                    </div>
                    )}
                    apply={ () => {
                        this._mailDelSubmit(this.state.mailApproachDelId);
                        this.setState({mailApproachDelId: null});
                      }
                    }
                    close={ () => this.setState({mailApproachDelId: null}) }
                  />
                </div>

              </div>
              <div
                style={{
                  display: (this.state.textareaFocus) ? 'block' : 'none',
                  position:'absolute',
                  top: '0px',
                  left: '0px',
                  height: '100%',
                  width: '100%',
                }}
                onClick={ () => this._textareaBlur() }
              />
            </div>

            <div id='mail_form_block' style={{background:'#F5F5F5'}}>

              <div
                style={{
                  display:'flex',
                  flexDirection:'row',
                  padding:'10px 10px 15px 10px',
                }}
              >
                <div
                  style={{
                    flexDirection:'column',
                    justifyContent:'middle',
                    marginRight:'5px',
                    display:((this.state.textareaFocus) ? 'none' : 'flex'),
                  }}
                >
                  <div align='center' style={{fontSize:'0.8em',color:'#666'}}>
                    ╲あとで消せる╱
                  </div>
                  <div align='center'>
                    <div
                      style={{
                        display:'flex',
                        flexDirection:'row',
                      }}
                    >
                      <div style={{flexDirection:'column', justifyContent:'center'}}>
                        <div
                          onClick={ () => this.setState({ dialogPhotoMailVisible: true}) }
                          style={{width:'52px',textAlign:'center',color:'#666',lineHeight:'1em',cursor:'pointer'}}
                        >
                          <div><CameraAltIcon /></div>
                          <div>写真</div>
                        </div>
                      </div>

                      <div style={{display:((this.state.textareaFocus) ? 'none' : 'block'), flexDirection:'column', justifyContent:'center'}}>
                        <div
                          onClick={ () => this.setState({ dialogVoiceMailVisible: true}) }
                          style={{width:'52px',textAlign:'center',color:'#666',lineHeight:'1em',cursor:'pointer'}}
                        >
                          <div><MicIcon /></div>
                          <div>ボイス</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{width:'100%',position:'relative'}}>
                  <div align='center' style={{display:((this.state.textareaFocus) ? 'block' : 'none'), }}>
                    {
                      (this.state.mailSendCheckType === 'approach') && (
                        <div style={{color:'#666'}}>
                          無料メールは<span className='link' onClick={ () => this.props.helpOpen('id','413') }><u>ガイドライン</u></span>に<br/>
                          沿って作成してください
                        </div>
                      )
                    }
                    {
                      (this.state.mailSendCheckType === 'noCharge')  && (
                        <div style={{color:'#666'}}>
                          {this.state.mailSendCheckComment}<br/>
                          <span className='link' onClick={ () => this.setState({dialogTextMailSendVisible:true}) }><u>もっとメールを送るには？</u></span>
                        </div>
                      )
                    }


                  </div>
                  <TextareaAutosize
                    id='textarea'
                    ref={this.textareaRef}
                    value={this.state.textareaText}
                    className="input_blue round6 scroll_touch"
                    onChange={(e) => this.setState({ textareaText: e.target.value})}
                    onFocus={ () => this._textareaFocus() }
                    onHeightChange={ () => this._adjustBlockHeight() }
                    style={{
                      fontSize: '1.2em',
                      resize: 'none',
                    }}
                    minRows={this.state.textareaMinRows}
                    maxRows={this.state.textareaMaxRows}
                    placeholder="メールの本文を入力してください"
                  >
                  </TextareaAutosize>
                  <span
                    style={{
                      position:'absolute',
                      bottom:'-12px',
                      right:'0px',
                      fontSize:'0.8em',
                      display:((this.state.textareaFocus) ? 'block' : 'none')
                    }}
                  >
                    { textareaTextValidComment }
                  </span>
                </div>
                <div style={{display:'flex', flexDirection:'column', justifyContent:'flex-end', marginLeft:'5px'}}>

                  <div style={{display:((this.state.textareaFocus) ? 'block' : 'none'), marginBottom:'5px'}}>
                    <Button
                      color="primary"
                      variant="outlined"
                      onClick={ () => {
                        this._mailDraftSave();

                      }}
                      style={{paddingLeft:0,paddingRight:0}}
                      disabled={ (this.state.textareaText.length < 1500) ? false: true }
                    >
                      保存
                    </Button>
                  </div>

                  <div style={{marginBottom:'5px'}}>
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={ () => {
                        this.setState({dialogTextMailSendVisible:true});
                      }}
                      style={{paddingLeft:0,paddingRight:0}}
                      disabled={ (textareaTextValid) ? false: true }
                    >
                      送信
                    </Button>
                  </div>
                </div>
              </div>

              <DialogTextMailSend
                open={this.state.dialogTextMailSendVisible}
                close={ () => this.setState({dialogTextMailSendVisible: false}) }
                checkBool={this.state.mailSendCheckBool}
                checkLeft={this.state.mailSendCheckLeft}
                checkType={this.state.mailSendCheckType}
                checkComment={this.state.mailSendCheckComment}
                textareaText={this.state.textareaText}
                submit={ (type) => this._mailSubmit(type) }
              />

              <DialogPhotoMailSelect
                open={this.state.dialogPhotoMailVisible}
                close={ () => this.setState({dialogPhotoMailVisible: false}) }
                checkBool={this.state.mailSendCheckBool}
                checkLeft={this.state.mailSendCheckLeft}
                checkType={this.state.mailSendCheckType}
                checkComment={this.state.mailSendCheckComment}
                photoMailImageBase64={this.state.photoMailImageBase64}
                setPhotoMailImageBase64={(e) => this.setState({ photoMailImageBase64: e})}
                submit={ (type) => this._mailSubmit(type) }
              />

              <DialogVoiceMailRecord
                open={this.state.dialogVoiceMailVisible}
                close={ () => this.setState({dialogVoiceMailVisible:false, voiceMailAudioWav:null}) }
                checkBool={this.state.mailSendCheckBool}
                checkType={this.state.mailSendCheckType}
                checkComment={this.state.mailSendCheckComment}
                setVoiceMailAudioWav={ (e) => this.setState({ voiceMailAudioWav: e}) }
                voiceMailAudioWav={this.state.voiceMailAudioWav}
                submit={ (type) => this._mailSubmit(type) }
              />

              <DialogVideoMailPlay
                open={(this.state.videoPlayUri) ? true : false}
                close={ () => this.setState({videoPlayUri: null}) }
                videoPlayUri={this.state.videoPlayUri}
              />

            </div>
        </div>
      </Box>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    config: state.config,
    auth: state.auth,
    my: state.my,
    mailbox: state.mailbox,
    mailDraft: state.mailDraft,
  }
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    ...uiAction,
    ...mailTalkAction,
    ...mailGroupAction,
    ...mailDraftAction,
    ...partnerOperationAction,
    ...lightboxAction,
    ...helpAction,
    ...guideAction,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
